import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  set(item: string, value: string) {
    localStorage.setItem(item, value);
  }

  get(item: string): string | null {
    return localStorage.getItem(item);
  }
}
